export const saveUserInfo = (isLogined = false, isGuest = false, userInfo) => {
  return {
    type : 'USER_INFO_SAVE',
    isLogined,
    isGuest,
    userInfo
  }
};
